import { brand, principles, stats, hotComments } from "@/mocks/gua";

export default function About() {
  return (
    <section id="about" className="mt-16 scroll-mt-24 px-4 md:mt-24 md:px-6">
      <div className="mx-auto max-w-[1240px]">
        {/* 数据条 */}
        <div className="mb-6 grid grid-cols-2 gap-3 lg:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-lg border border-background-200 bg-background-100/50 px-4 py-5 text-center">
              <p className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">{s.num}</p>
              <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {/* 关于正文 */}
          <div className="flex flex-col gap-4 rounded-xl border border-background-200 bg-background-100/50 p-6 md:p-8">
            <p className="mb-1 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-primary-600">
              <i className="ri-quill-pen-line" /> 关于 {brand.name}
            </p>
            <h2 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
              {brand.slogan}
            </h2>
            <p className="text-sm leading-relaxed text-foreground-600">{brand.desc}</p>
            <p className="text-sm leading-relaxed text-foreground-600">
              我们相信，吃瓜的价值不止在于「追得快」，更在于「看得懂」。因此每一篇内容都尽力做到：交代事件起因、梳理关键节点、呈现多方回应、标记未证实信息，再把舆论为何如此走向讲给你听。
            </p>
            <div className="mt-1 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {principles.map((p) => (
                <div key={p.title} className={`rounded-lg p-4 ${p.tag === "accent" ? "bg-accent-100" : "bg-secondary-100"}`}>
                  <i className={`mb-2 inline-block text-xl ${p.tag === "accent" ? "text-accent-600" : "text-secondary-700"}` + " " + p.icon} />
                  <h3 className="text-sm font-semibold text-foreground-900">{p.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 口碑 */}
          <div className="flex flex-col rounded-xl bg-foreground-950 p-6 md:p-8">
            <div className="mb-5 flex items-center justify-between">
              <h3 className="font-heading text-lg font-bold text-white">常读读者的真实感受</h3>
              <div className="flex items-center gap-1 text-secondary-400">
                <i className="ri-star-fill" /><i className="ri-star-fill" /><i className="ri-star-fill" /><i className="ri-star-fill" /><i className="ri-star-half-fill" />
              </div>
            </div>
            <div className="flex flex-col gap-4">
              {hotComments.map((c) => (
                <div key={c.text} className="flex gap-3 rounded-lg bg-white/5 p-4">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500/80 text-background-50">
                    <i className="ri-chat-quote-line text-sm" />
                  </span>
                  <div>
                    <p className="text-sm leading-relaxed text-white/90">“{c.text}”</p>
                    <div className="mt-2 flex items-center gap-2 text-xs text-white/55">
                      <span>{c.name.replace(",", "")}</span>
                      <span className="rounded bg-accent-500/80 px-1.5 py-0.5 text-[11px] text-background-50">{c.mark}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <p className="mt-auto pt-5 text-xs leading-relaxed text-white/45">
              期待你的视角。有值得深挖的热点，欢迎通过下方订阅与联系我们投递线索。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}